import 'css-chunksrc/client/scenes/constrainElement/constrainedElement/element/task/styles.scss';export default {
  "task": "_task_4fagd_1",
  "completed": "_completed_4fagd_9",
  "late": "_late_4fagd_9",
  "unScheduled": "_unScheduled_4fagd_13",
  "withStartDate": "_withStartDate_4fagd_17",
  "withEndDate": "_withEndDate_4fagd_21"
};